var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Quiz',_vm._b({},'Quiz',_vm.props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }